var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getFileList.length)?_c('sky-upload-img',{attrs:{"disabled":true,"readOnly":true,"value":_vm.getFileList}}):_c('i',[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }